import { DEFAULT_PRIVACY_CONTACT_EMAIL } from '@digitaltattoo/shared-utils';

export const legalConfig = {
  privacyPolicyUrl: import.meta.env.VITE_PRIVACY_POLICY_URL || 'https://abraxas.fr/politique-de-confidentialite',
  staffPrivacyNoticeUrl: import.meta.env.VITE_STAFF_PRIVACY_NOTICE_URL || '/manual/fr/11-journal-audit.html',
  privacyContactEmail: import.meta.env.VITE_PRIVACY_CONTACT_EMAIL || DEFAULT_PRIVACY_CONTACT_EMAIL,
};
